export const LOG = {
  FETCH_ALL: 'LOG.FETCH_ALL',
  FETCH_ALL_FAILED: 'LOG.FETCH_ALL_FAILED',
  SET_ALL: 'LOG.SET_ALL',
};

export const fetchLogsByDeviceId = (deviceId) => ({
  type: LOG.FETCH_ALL,
  payload: {data: deviceId}
});


// WEBPACK FOOTER //
// ./src/actions/log.js